import { render, staticRenderFns } from "./demandrecView.vue?vue&type=template&id=0ac8b7be&scoped=true&"
import script from "./demandrecView.vue?vue&type=script&lang=js&"
export * from "./demandrecView.vue?vue&type=script&lang=js&"
import style0 from "./demandrecView.vue?vue&type=style&index=0&id=0ac8b7be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac8b7be",
  null
  
)

export default component.exports